import { EnhancementService, RenderService } from '@web-rendering/groundcontrol-core';
import gc from './index';
import { EqtBeaconService, EqtConfigurationSettings, EquativPayloadService } from '@web-rendering/groundcontrol-eqt';
import { Banner } from '@web-rendering/groundcontrol-ad-unit/components/banner/banner-unenhanced.component';

gc({
  payloadService: new EquativPayloadService(),
  trackerService: new EqtBeaconService(),
  configurationService: new EqtConfigurationSettings(),
  renderService: new RenderService(Banner),
  enhancementService: new EnhancementService(undefined)
});
